import { render, staticRenderFns } from "./SSelectProperty.vue?vue&type=template&id=1dd6905f"
import script from "./SSelectProperty.vue?vue&type=script&lang=js"
export * from "./SSelectProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports